import React from 'react';
import { BrowserRouter, NavLink, Link } from 'react-router-dom';
import { WebsiteName } from '../../App';
import HeroPage from '../Hero/HeroPage';
import AboutRight from '../Sections/AboutRight';
import Resume from "../../doc/Wasek Bellah's Resume.pdf";
import workData from '../../PostData/workData';
import AboutSocial from '../Sections/AboutSocial';

const About = () => {
    document.title = "About | " + WebsiteName;

    return (
        <>
            <HeroPage title="About me"></HeroPage>

            <main>
                {/* Testimonials */}
                <section className="about" id="about">
                    <div className="container">
                        <div className="aboutContent">
                            <div className="left">
                                <p>An exceptionally skilled and professional Web Developer, React Developer, and WordPress Developer with expertise in React eCommerce Website Development, HTML CSS, Responsive Website Design, WordPress Theme Development. I know how to improve the core functionality of a website on the Internet and to also be involved in its future development.</p>

                                {workData.length !== 0 && <p>Please have a look at my some &nbsp;
                                    <BrowserRouter forceRefresh={true}>
                                        <NavLink exact to="/latest-work" className="contentLink">Projects</NavLink>
                                    </BrowserRouter>
                                .</p>}

                                <h3>I am expert in the following sectors:</h3>
                                <ul>
                                    <li>✔ React Development</li>
                                    <li>✔ WordPress Theme Development</li>
                                    <li>✔ Responsive Website Design with HTML CSS and Bootstrap</li>
                                    <li>✔ Contact Form Development with PHP</li>
                                    <li>✔ PSD to HTML CSS and Bootstrap conversion</li>
                                    <li>✔ PSD to WordPress Theme</li>
                                    <li>✔ HTML Template to WordPress Theme</li>
                                    <li>✔ WordPress Migration</li>
                                    <li>✔ Website Re-Design</li>
                                    <li>✔ Node</li>
                                    <li>✔ HTML5</li>
                                    <li>✔ CSS3 (including Flexbox, Grid)</li>
                                    <li>✔ Sass</li>
                                    <li>✔ Bootstrap</li>
                                </ul>

                                <p>Fell free to contact me.</p>

                                <AboutSocial></AboutSocial>

                                <Link to={Resume} className="btn-text" target="_blank">My Resume</Link>
                            </div> {/* Left */}

                            <AboutRight></AboutRight>
                        </div> {/* About Content */}
                    </div> {/* Container */}
                </section> {/* About */}
            </main>
        </>
    );
};

export default About;